theme_custom.realPeoplePopupSlider = function () {
  function waitForSlick(callback) {
    if (typeof $.fn.slick === "function") {
      callback()
    } else {
      setTimeout(() => waitForSlick(callback), 100)
    }
  }

  waitForSlick(() => {
    const $slider = $(".multiple_poup_slider")
    if ($slider.length && !$slider.hasClass("slick-initialized")) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        speed: 800,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              dots: true,
              arrows: true, // Keep arrows visible on all resolutions
            },
          },
        ],
      })
    }
  })
}

theme_custom.multipleResultSlider = function () {
  const $slider = $(".multiple-result-sliders")
  $slider.on("init", function (event, slick) {
    if (window.innerWidth > 1024) {
      if (slick.slideCount <= 3) {
        $slider.find(".slick-track").css({
          "margin-left": "0",
          "margin-right": "0",
        })
        $slider.find(".slick-dots").hide()
      }
    }
  })
  $(window).on("resize", function () {
    $slider.slick("resize")
    if (window.innerWidth > 1024) {
      $slider.slick("setPosition")
    }
  })

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.35,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.15,
          arrows: false,
          dots: true,
        },
      },
    ],
  })
}

theme_custom.mainProductSlider = function () {
  $(document).ready(function () {
    $(".slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      infinite: false,
      fade: true,
      asNavFor: ".slider-nav",
    })

    let $sliderNav = $(".slider-nav")

    $sliderNav.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      vertical: true,
      arrows: true,
      asNavFor: ".slider-for",
      dots: false,
      infinite: false,
      focusOnSelect: true,
      verticalSwiping: true,
      centerMode: true,
      centerPadding: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5.2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    })
    function removeAriaHidden() {
      $(".slick-slide[aria-hidden='true']").removeAttr("aria-hidden")

      $(".slick-slide").each(function () {
        let $slide = $(this)
        let isHidden = $slide.attr("aria-hidden") === "true"
        let $button = $slide.find("button")

        $button.attr("tabindex", isHidden ? "-1" : "0")
        $button.attr("role", "tab")
        $slide.removeAttr("tabindex")
      })
    }

    function preventHiddenElementFocus() {
      $(document).on("focusin", function (event) {
        let $focusedElement = $(event.target)
        let $hiddenAncestor = $focusedElement.closest(
          '.slick-slide[aria-hidden="true"]',
        )

        if ($hiddenAncestor.length > 0) {
          setTimeout(() => {
            $focusedElement.blur()
            $(".slider-nav .slick-current button").focus()
          }, 10)
        }
      })
    }

    function watchAriaHiddenChanges() {
      new MutationObserver(() => removeAriaHidden()).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["aria-hidden"],
      })
    }

    $(".slider3").slick({
      dots: true,
      infinite: false,
      slidesToShow: 1.2,
      vertical: false,
      arrows: false,
      draggable: true,
    })

    $(".slider3").on("afterChange", function (event, slick, currentSlide) {
      const $track = $(slick.$slider).find(".slick-track")
      const style = $track.css("transform")

      if (style !== "none") {
        const values = style.match(/matrix.*\((.+)\)/)[1].split(", ")
        let tx = parseFloat(values[4])

        tx -= 200

        $track.css("transform", `translateX(${tx}px)`)
      } else {
        $track.css("transform", "translateX(-200px)")
      }

      let slidetx = 10
      if (window.innerWidth >= 768) {
        slidetx = 18
      }

      if (
        $(".gallery-frame.slick-slide:last-of-type").hasClass("slick-active")
      ) {
        $(this)
          .find(".gallery-frame")
          .css("transform", `translateX(${slidetx}px)`)
      } else {
        $(this).find(".gallery-frame").css("transform", "translateX(0px)")
      }

      handleSlideChange(slick, this.id)
    })

    // Play/pause videos based on active slide
    function handleSlideChange(slick, slider) {
      const currentIndex = slick.currentSlide

      // Pause all videos in the slider
      document
        .querySelectorAll(`#${slider} .gallery-frame video`)
        .forEach((video) => {
          video.pause()
        })

      // Play the video in the currently active slide
      const activeSlideVideo = document.querySelector(
        `#${slider} .slick-slide[data-slick-index="${currentIndex}"] video`,
      )

      if (activeSlideVideo) {
        activeSlideVideo.play().catch((err) => {
          // Handle autoplay restrictions or errors
          console.warn("Video play failed:", err)
        })
      }
    }

    // Custom transform on afterChange
    function shiftTrack(slick) {
      requestAnimationFrame(() => {
        const $track = $(slick.$slider).find(".slick-track")
        const style = $track.css("transform")

        if (style !== "none") {
          try {
            const values = style.match(/matrix.*\((.+)\)/)[1].split(", ")
            let tx = parseFloat(values[4])

            let ty = $(slick.$slider)
              .parents(".compare--product_list")
              .find(".first_product_card")
              .outerWidth()

            if (slick.slideCount == 2 && slick.currentSlide >= 1) {
              tx = -(ty * slick.currentSlide)
            } else if (slick.slideCount == 3 && slick.currentSlide >= 1) {
              tx = -(ty * slick.currentSlide)
            } else {
              tx = 0
            }
            // Enable smooth transition
            $track.css({
              transition: "transform .6s ease",
              "will-change": "transform",
              left: "0",
              transform: `translate3d(${tx}px, 0px, 0px)`,
              "max-width": `${ty * slick.slideCount + 5}px`,
            })
          } catch (e) {
            console.warn("Transform parsing failed:", e)
          }
        }
      })
    }

    const $comparisionSlider = $(".compare--product_wrapper")

    $comparisionSlider.on("afterChange", function (event, slick) {
      setTimeout(() => {
        shiftTrack(slick)
      }, 10)
    })

    let wasDragged = false

    $comparisionSlider.on("mousedown touchstart", () => {
      wasDragged = false
    })

    $comparisionSlider.on("mousemove touchmove", () => {
      wasDragged = true
    })

    // if ($comparisionSlider.length === 0)
    //   throw new Error("Slider element not found")

    // Bind init event BEFORE initialization
    $comparisionSlider.on("init", function (event, slick) {
      try {
        if (slick.$dots.prevObject[0].childElementCount <= 1) {
          $(this).addClass("only-one-slide")
          $(this)
            .parent(".compare--product_list")
            .find(".product-overview__product-card")
            .css("margin-bottom", "0")
          $(this).find(".slick-dots, .slick-arrow").hide()
        }

        setTimeout(() => {
          shiftTrack(slick)
        }, 10)
      } catch (err) {
        console.error("Error in slick init event:", err)
      }
    })

    // Between 600 and 767 → destroy Slick if initialized
    if ($(window).width() >= 600 && $(window).width() <= 767) {
      if ($comparisionSlider.hasClass("slick-initialized")) {
        $comparisionSlider.slick("unslick")
      }
    } else {
      // Initialize Slick
      $comparisionSlider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        draggable: true,
        speed: 0,
        useTransform: false,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 2.1,
            },
          },
          {
            breakpoint: 1439,
            settings: {
              slidesToShow: 1.3,
            },
          },
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2.1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1.4,
            },
          },
        ],
      })
    }

    $sliderNav.on("init afterChange", removeAriaHidden)

    removeAriaHidden()
    preventHiddenElementFocus()
    watchAriaHiddenChanges()
  })
}

// Function to handle slider reinitialization
theme_custom.percussiveMassageSlider = function () {
  // Safety check: ensure Slick is loaded
  if (typeof $.fn.slick !== "function") {
    return
  }

  const pmSlider = $(".multiple-video-massages:not(.slick-initialized)").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 16000,
    fade: true,
    cssEase: "linear",
    initialSlide: 0,
  })
  if (pmSlider.slick("getSlick").slideCount > 1) {
    setTimeout(function () {
      $(".multiple-video-massages").slick("slickGoTo", 1) // Move to the second slid
    }, 100)
  }
}

setTimeout(function () {
  if (
    typeof $.fn.slick === "function" &&
    $(".multiple-video-massages").hasClass("slick-initialized")
  ) {
    $(".multiple-video-massages").slick("slickNext")
  }
}, 17000)

// Handle the last slide scenario
function handleLastSlide(slick) {
  const totalSlides = slick.slideCount

  if (slick.currentSlide === totalSlides - 1) {
    // Unslick (destroy) the current slider
    $(".multiple-video-massages").slick("unslick")

    // Reinitialize the slider and wait for 'init' to move to the second slide
    theme_custom.percussiveMassageSlider()
  }
}

// Listen to the 'beforeChange' event
$(document).on(
  "beforeChange",
  ".multiple-video-massages",
  function (event, slick, currentSlide) {
    handleLastSlide(slick)
  },
)

$(document).on(
  "afterChange",
  ".multiple-video-massages",
  function (event, slick, currentSlide) {
    console.log("Active slide index:", currentSlide) // Debugging the active slide index
    // You can also manually check the active class if needed
    const totalSlides = slick.slideCount // Get the total number of slides
    setTimeout(function () {
      // Check if the next slide is the last one
      if (currentSlide === totalSlides - 1) {
        setTimeout(function () {
          $(".multiple-video-massages").slick("slickGoTo", 1) // Move to the second slid
        }, 16000)
      }
    }, 500) // Delay to ensure the slider is initialized

    $(".multiple-video-massages .slick-slide").removeClass("slick-active")
    $(".multiple-video-massages .slick-slide")
      .eq(currentSlide)
      .addClass("slick-active")
  },
)

theme_custom.searchSortChange = function () {
  let selectedSortName = $(".multiple-custom-sort-options input:checked").attr(
    "data-sort",
  )
  $(".selected-sort-custom").text(selectedSortName)
  let filterCountFind = $(".mobile-facets__main.gradient input:checked").length
  if (filterCountFind > 0) {
    $(".custom-filter-counts").removeClass("hidden")
    $(".custom-filter-counts").text(filterCountFind)
  } else {
    $(".custom-filter-counts").addClass("hidden")
  }
}

document.addEventListener("DOMContentLoaded", function (event) {
  // Ensure theme_custom exists so optional section initializers can be safely guarded.
  window.theme_custom = window.theme_custom || {}
  const theme_custom = window.theme_custom

  // Wait for Slick to be loaded before running realPeoplePopupSlider
  function waitForSlick(callback) {
    if (typeof $.fn.slick === "function") {
      callback()
    } else {
      setTimeout(() => waitForSlick(callback), 100)
    }
  }

  // IMPORTANT: Do NOT initialize `.multiple_poup_slider` (Real People popup) globally on DOMContentLoaded.
  // It lives inside a hidden popup; initializing Slick while hidden can lock it to slide 0 on iOS.
  // The Real People section script (`assets/custom-real-people.js`) initializes the popup slider on open
  // (when it has a real width) and then navigates to the clicked slide.
  if (typeof theme_custom.mainProductSlider === "function") {
    theme_custom.mainProductSlider()
  }
  // Real People section JS may not be present on every page.
  if (typeof theme_custom.mainRealPeopleBlock === "function") {
    theme_custom.mainRealPeopleBlock()
  }
  if (typeof theme_custom.multipleResultSlider === "function") {
    theme_custom.multipleResultSlider()
  }
  // Wait for Slick to be loaded before initializing percussiveMassageSlider
  waitForSlick(() => {
    if (typeof theme_custom.percussiveMassageSlider === "function") {
      theme_custom.percussiveMassageSlider()
    }
  })
  if (typeof theme_custom.searchSortChange === "function") {
    theme_custom.searchSortChange()
  }
  $(".multiple-video-massages").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      $(this).removeClass("hide-dots-custom")
      $(".main-video-blocks").removeClass("active")
    },
  )
})

class HotspotModal extends HTMLElement {
  constructor() {
    super()
    this.modal = this.querySelector(".hotspot-modal")
    this.button = this.querySelector("button")

    this.button.addEventListener("click", this.toggleModal.bind(this))
  }

  toggleModal() {
    this.button.classList.toggle("button--active")
    this.modal.classList.toggle("hidden")
  }
}
customElements.define("hotspot-modal", HotspotModal)

class HeroMultiproductImage extends HTMLElement {
  constructor() {
    super()
    this.scrollTimeout = null
    this.productList = this.querySelector("ul")
    this.defaultAnimationDuration = 6

    this.segmentContainer = this.querySelector(".hero-mp-image__segments")
    this.segments =
      this.segmentContainer &&
      this.segmentContainer.querySelectorAll(".segment")
    this.productCards = this.querySelectorAll(".product-card-container")
    this.productCardSlider = this.querySelector(".product-card-slider")
  }

  static get observedAttributes() {
    return ["static", "default-animation-duration"]
  }

  connectedCallback() {
    const isStatic = this.getAttribute("static") || false
    if (isStatic && isStatic === "true") {
      return
    }
    const hMpImg = this
    window.addEventListener("resize", function (event) {
      // fix slide alignment issue on resize
      if (!hMpImg.productList.classList.contains("slide-target-card")) {
        hMpImg.productList.style.scrollBehavior = "auto"
        hMpImg.productList.scrollLeft =
          hMpImg.getActiveSegmentIndex() * hMpImg.productList.clientWidth
        hMpImg.productList.style.scrollBehavior = "smooth"
      }
    })
    this.setUp()
  }

  disconectedCallback() {
    this.cleanUp()
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "default-animation-duration": {
        this.defaultAnimationDuration = newValue || 6
        break
      }
      case "static": {
        if ((!oldValue || oldValue === "false") && newValue === "true") {
          this.cleanUp()
        } else if (oldValue === "true" && (!newValue || newValue === "false")) {
          this.setUp()
        }
        break
      }
    }
  }

  setUp() {
    let firstProductDuration = this.defaultAnimationDuration
    this.productList.querySelectorAll("li").forEach((productItem, index) => {
      const video = productItem.querySelector("video")
      const duration =
        (video && video.duration) || this.defaultAnimationDuration
      if (index === 0) {
        firstProductDuration = duration
      }
      this.segments[index].querySelector(".progress").style =
        `animation-duration: ${duration}s;`
    })
    if (this.productList.classList.contains("slide-target-card")) {
      let productCards = this.productList.querySelectorAll(
        ".product-card-container",
      )
      productCards.forEach((el) => (el.style.display = "none"))
      this.productCardSlider.innerHTML = this.productCards[0].innerHTML
      this.productCardSlider.classList.add("product-card-container")
    }

    this.scheduleScrollToNextProduct(firstProductDuration)
    this.querySelectorAll(".hero-mp-image__thumbnail button").forEach(
      (button) =>
        button.addEventListener("click", this.scrollToNextProduct.bind(this)),
    )
    this.querySelectorAll(".hero-mp-image__toggle-animation button").forEach(
      (button) =>
        button.addEventListener("click", this.toggleScrollSchedule.bind(this)),
    )
    this.querySelectorAll("button.hero-mp-sale__carousel-prev").forEach(
      (anchor) =>
        anchor.addEventListener("click", this.scrollToPrevProduct.bind(this)),
    )
    this.querySelectorAll("button.hero-mp-sale__carousel-next").forEach(
      (anchor) =>
        anchor.addEventListener("click", this.scrollToNextProduct.bind(this)),
    )
  }

  cleanUp() {
    clearTimeout(this.scrollTimeout)
    this.scrollTimeout = null

    this.querySelectorAll(".hero-mp-image__thumbnail button").forEach(
      (button) => button.removeEventListener("click", this.scrollToNextProduct),
    )
    this.querySelectorAll(".hero-mp-image__toggle-animation button").forEach(
      (button) =>
        button.removeEventListener("click", this.toggleScrollSchedule),
    )
    this.querySelectorAll("button.hero-mp-sale__carousel-prev").forEach(
      (anchor) => anchor.removeEventListener("click", this.scrollToPrevProduct),
    )
    this.querySelectorAll("button.hero-mp-sale__carousel-next").forEach(
      (anchor) => anchor.removeEventListener("click", this.scrollToNextProduct),
    )
  }

  scrollToProduct(scrollIndex) {
    this.segmentContainer
      .querySelector(".segment--active")
      .classList.remove("segment--active")
    this.segments[scrollIndex].classList.add("segment--active")
    const scrollProduct = this.productList.querySelectorAll("li")[scrollIndex]
    const video = scrollProduct.querySelector("video")
    if (video) {
      video.currentTime = 0
    }
    if (this.productList.classList.contains("slide-target-card")) {
      let newCard = this.productCards[scrollIndex].innerHTML
      jQuery(".product-card-slider")
        .css({ display: "block" })
        .fadeOut(500, () => {
          jQuery(".hero-mp-sale__carousel-current", this).html(scrollIndex + 1)
          jQuery(".product-card-slider", this).html(newCard).fadeIn()
        })
    } else {
      this.productList.scrollLeft = scrollIndex * this.productList.clientWidth
    }

    const duration = this.getStyleAnimationDuration(
      this.segments[scrollIndex].querySelector(".progress"),
    )
    if (!!this.scrollTimeout) {
      this.scheduleScrollToNextProduct(duration)
    }
  }

  getActiveSegmentIndex() {
    let activeSegmentIndex = 0
    for (let i = 0; i < this.segments.length; i++) {
      if (this.segments[i].classList.contains("segment--active")) {
        activeSegmentIndex = i
        break
      }
    }
    return activeSegmentIndex
  }
  scrollToPrevProduct() {
    let activeSegmentIndex = this.getActiveSegmentIndex()
    const scrollIndex =
      activeSegmentIndex === 0
        ? this.segments.length - 1
        : activeSegmentIndex - 1
    this.scrollToProduct(scrollIndex)
  }

  scrollToNextProduct() {
    let activeSegmentIndex = this.getActiveSegmentIndex()
    const scrollIndex =
      activeSegmentIndex === this.segments.length - 1
        ? 0
        : activeSegmentIndex + 1
    this.scrollToProduct(scrollIndex)
  }

  toggleScrollSchedule(event) {
    const toggleAnimationButton = event.currentTarget
    const hasResumed = toggleAnimationButton.classList.toggle("button--active")
    this.segmentContainer.classList.toggle("paused")

    if (hasResumed) {
      const animationProgress = this.segmentContainer.querySelector(
        ".segment--active .progress",
      )
      const duration = this.getStyleAnimationDuration(animationProgress)
      const remainingDuration =
        duration -
        (animationProgress.getAnimations()[0].currentTime / 1000 || 0)
      this.scheduleScrollToNextProduct(remainingDuration)
    } else {
      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = null
    }

    this.productList.querySelectorAll("video").forEach((video) => {
      if (hasResumed) {
        video.play()
      } else {
        video.pause()
      }
    })
  }

  scheduleScrollToNextProduct(duration = this.defaultAnimationDuration) {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }

    this.scrollTimeout = setTimeout(
      this.scrollToNextProduct.bind(this),
      duration * 1000,
    )
  }

  getStyleAnimationDuration(el) {
    const duration = el.style.animationDuration
    return duration.substring(0, duration.length - 1)
  }
}
customElements.define("hero-multiproduct-image", HeroMultiproductImage)

// const cookieKey = "united_activated"
// const updateVisibility = () => {
//   const isActive = getCookie(cookieKey) === "true"

//   document
//     .querySelectorAll(".mileage-tags")
//     .forEach((el) => (el.style.display = isActive ? "flex" : "none"))
// }

// const getCookie = (name) => {
//   const cookies = document.cookie.split("; ").reduce((acc, currentCookie) => {
//     const [key, value] = currentCookie.split("=")
//     acc[key] = value
//     return acc
//   }, {})
//   return cookies[name]
// }

const swatchChangesCard = (evnt) => {
  const option = evnt.target
  const card = option.closest(".card")
  if (!card) return
  // Daily Deals has its own swatch handler; avoid double-processing there.
  if (card.closest(".daily-deals-grid")) return

  // When the rating quick filter is active, it can auto-switch swatches to satisfy the rating rule.
  // Mark a short "user is interacting with swatches" window so the rating filter won't override
  // the user's selection (prevents a one-time snap back to default swatch).
  try {
    const li = card.closest("li.grid__item")
    if (li) li.dataset.yotpoRatingUserSwatchTs = String(Date.now())
  } catch (_) {}

  const prodUrl = option.getAttribute("data-prod-url")

  const variantTogglers = card.querySelectorAll(".custom-swatches-check")
  for (var k = 0; k < variantTogglers.length; k++) {
    variantTogglers[k].classList.remove("active")
  }
  option.classList.add("active")
  if (prodUrl) card.setAttribute("data-prod-url", prodUrl)

  // Optional fields (not all card templates include these)
  const badgesClass = option.getAttribute("data-badges")
  const badgesCustomText = option.getAttribute("data-custom-badge-text")
  const couponBadgeBottomText = option.getAttribute("data-discount_code")
  const badgesEl = card.querySelector(".badges")
  if (badgesEl && badgesClass != null) {
    badgesEl.setAttribute("class", "badges" + badgesClass)
    if (badgesClass == " custom-badge" && badgesCustomText) {
      badgesEl.querySelector(".new_tags") &&
        (badgesEl.querySelector(".new_tags").innerHTML = badgesCustomText)
    }
    if (badgesClass == " new" && badgesCustomText) {
      badgesEl.querySelector(".new_tags") &&
        (badgesEl.querySelector(".new_tags").innerHTML = badgesCustomText)
    }
  }

  const isExclusive = option.getAttribute("data-exclusive-badge") === "true"
  card.querySelector(".exclusive-badge").style.display = isExclusive
    ? "flex"
    : "none"

  const bottomTextEl = card
    .closest(".product-card-wrapper")
    ?.querySelector(".promotional-messaging-bottom-text")
  if (bottomTextEl) {
    if (couponBadgeBottomText) {
      bottomTextEl.innerHTML = `<p class="coupon-bottom-text">
        ${couponBadgeBottomText}</p>`
    } else {
      bottomTextEl.innerHTML = ""
    }
  }

  const price = option.getAttribute("data-price")
  const sale = option.getAttribute("data-sale")
  const original = option.getAttribute("data-original")
  const priceWrapper = card.querySelector(".price-item")
  const saleWrapper = card.querySelector(".price__sale")
  let salebadge = card.querySelector(".badge[data-sale-badge-label-type]")
  salebadge.setAttribute(
    "data-sale-badge-label-type",
    `${option.getAttribute("data-sale-badge-label-type")}`,
  )

  initBadges()

  if (original && saleWrapper) {
    const discount = sale ? sale : price
    saleWrapper.innerHTML = `<span class="sale_price_custom">${discount || ""}</span> <span class="org_prod_price">${original}</span>`
  } else if (sale && priceWrapper) {
    priceWrapper.innerHTML = `<span class="sale_price_custom">${sale}</span> <span class="org_prod_price">${price || ""}</span>`
  } else if (price && priceWrapper) {
    priceWrapper.innerHTML = price
  }
  const imageSrc = option.getAttribute("variant_image")
  const firstImage = card.querySelector(".card__media img")
  if (imageSrc && firstImage) {
    firstImage.src = imageSrc
    firstImage.srcset = imageSrc
  }
  const hoverSrc = option.getAttribute("data-variant-hover")
  const hoverImage = card.querySelector(".card__media img.hover")
  if (hoverSrc && hoverImage) {
    hoverImage.src = hoverSrc
    hoverImage.srcset = hoverSrc
  }

  // --- Yotpo: refresh rating when swatch changes ---
  try {
    const newYotpoProductId = option.getAttribute("data-yotpo-product-id")
    const newYotpoShowHide = option.getAttribute("data-yotpo-show-hide")
    const newYotpoScore = option.getAttribute("data-yotpo-score")
    const widget = card.querySelector(".yotpo-widget-instance")
    if (widget && newYotpoProductId) {
      // Update the Yotpo "product id" used by the widget
      widget.setAttribute("data-yotpo-product-id", newYotpoProductId)
      if (newYotpoShowHide != null) {
        widget.setAttribute("data-yotpo-show-hide", newYotpoShowHide)
      }
      try {
        const raw = String(newYotpoScore || "").trim()
        if (raw) widget.setAttribute("data-yotpo-score", raw)
        else widget.removeAttribute("data-yotpo-score")
      } catch (_) {}

      // Reset our custom rendering state so footer enhancer re-renders correctly
      widget.classList.remove(
        "yotpo-card-ready",
        "yotpo-card-suppressed",
        "yotpo-plp-clean",
        "yotpo-plp-has-custom-rating",
      )
      widget.querySelector(".custom-yotpo-inline-rating")?.remove()
      widget.querySelector(".custom-yotpo-rating-number")?.remove()

      // Mark for processing and trigger a targeted refresh pass
      widget.dataset.yotpoNeedsRefresh = "1"
      document.dispatchEvent(
        new Event("yotpo:card:refresh", { bubbles: true, composed: true }),
      )
    }
  } catch (_) {}
  dataLayer.push({
    event: "color_swatch_select",
    selection: option.getAttribute("data-color"),
    page_location: window.location.href,
  })
}
// Bind once globally so swatches work in all contexts (PLP, featured collections, gift center, etc.).
if (!window.__swatchChangesCardBound) {
  window.__swatchChangesCardBound = true
  jQuery(document).on(
    "click",
    ".card .custom-swatches-check",
    swatchChangesCard,
  )
}

// Function to execute when the DOM changes
function onDomChange(mutationsList, observer) {
  mutationsList.forEach((mutation) => {
    //updateVisibility()
    // make whole product card clickable
    const cardBox = document.querySelectorAll(".card")
    for (var i = 0; i < cardBox.length; i++) {
      const cardInner = cardBox[i].querySelector(".card__inner")
      if (!cardInner.getAttribute("data-cardClick")) {
        cardInner.setAttribute("data-cardClick", true)
        cardInner.addEventListener(
          "click",
          (evt) => {
            const card = evt.target.closest(".card")
            Shopify.GA.cardClick(card)
            const prodUrl = card.getAttribute("data-prod-url")
            window.location.href = prodUrl
          },
          false,
        )
      }
    }
    // for all products
    // const cardBox = document.querySelectorAll(".card")
    // for (var i = 0; i < cardBox.length; i++) {
    //   if (!cardBox[i].getAttribute("data-clickable") || cardBox[i].getAttribute("data-clickable") != "true") {
    //     cardBox[i].setAttribute("data-clickable", true)
    //     cardBox[i].querySelector(".card__inner").addEventListener(
    //       "click",
    //       function (evnt) {
    //         const card = evnt.target.closest(".card")
    //         const prodUrl = card.getAttribute("data-prod-url")
    //         window.location.href = prodUrl
    //       },
    //       false,
    //     )
    //     const cardBox1 = document.querySelectorAll(".card")
    //     const variantTogglers = cardBox1[i].querySelectorAll(
    //       ".custom-swatches-check",
    //     )
    //     console.log(cardBox1[i],'====')

    //     for (var j = 0; j < variantTogglers.length; j++) {
    //       variantTogglers[j].addEventListener(
    //         "click",
    //         function (evnt) {
    //           evnt.stopPropagation()
    //           const option = evnt.target
    //           for (var k = 0; k < variantTogglers.length; k++) {
    //             variantTogglers[k].classList.remove("active")
    //           }
    //           option.classList.add("active")
    //           const card = option.closest(".card")
    //           card.setAttribute(
    //             "data-prod-url",
    //             option.getAttribute("data-prod-url"),
    //           )
    //           let badgesClass = option.getAttribute("data-badges")
    //           let badgesCustomText = option.getAttribute(
    //             "data-custom-badge-text",
    //           )
    //           card
    //             .querySelector(".badges")
    //             .setAttribute("class", "badges" + badgesClass)
    //           if (badgesClass == " custom-badge" && badgesCustomText != "") {
    //             card.querySelector(".badges.custom-badge .new_tags").innerHTML =
    //               badgesCustomText
    //           }
    //           if (badgesClass == " new" && badgesCustomText != "") {
    //             card.querySelector(".badges.new .new_tags").innerHTML =
    //               badgesCustomText
    //           }
    //           const price = option.getAttribute("data-price")
    //           const sale = option.getAttribute("data-sale")
    //           const original = option.getAttribute("data-original")
    //           const priceWrapper = card.querySelector(".price-item")
    //           if (sale != "") {
    //             priceWrapper.innerHTML = `<span class="sale_price_custom">${sale}</span> <span class="org_prod_price">${price}</span>`
    //           } else if (original && original != "") {
    //             card.querySelector(".price__sale").innerHTML =
    //               `<span class="sale_price_custom">${price}</span> <span class="org_prod_price">${original}</span>`
    //           } else {
    //             priceWrapper.innerHTML = price
    //           }
    //           const hoverSrc = option.getAttribute("data-variant-hover")
    //           const hoverImage = card.querySelector(".card__media img.hover")
    //           if (hoverSrc && hoverImage) {
    //             hoverImage.src = hoverSrc
    //             hoverImage.srcset = hoverSrc
    //           }
    //         },
    //         false,
    //       )
    //     }
    //   }
    // }

    // for popular product
    // const popularBox = document.querySelectorAll(".popular-product-block")

    // for (var i = 0; i < popularBox.length; i++) {
    //   const data_url = popularBox[i].getAttribute("data-prod-url")
    //   cardBox[i].addEventListener(
    //     "click",
    //     function () {
    //       window.location.href = data_url
    //       console.log(data_url)
    //     },
    //     false,
    //   )
    // }
  })
}

// Target the root element or a specific part of the DOM to observe
const targetNode = document.body

// Configure the observer
const config = {
  childList: true, // Detect additions or removals of child nodes
  subtree: true, // Observe changes in all child nodes as well
  attributes: true, // Set to true if you want to observe attribute changes
  characterData: false, // Set to true if you want to observe text node changes
}

// Create a new MutationObserver instance
const observer = new MutationObserver(onDomChange)

// Start observing the target node with the configured options
observer.observe(targetNode, config)

// Cart Add-On Slider Manager
class CartAddOnSlider {
  // Configuration constants
  static CONFIG = {
    SWIPER_MAX_RETRIES: 30,
    SWIPER_RETRY_DELAY: 150,
    CART_UPDATE_DELAY: 100,
    RESIZE_DEBOUNCE: 200,
    DESKTOP_BREAKPOINT: 1024,
    TABLET_BREAKPOINT: 768,
    IGNORED_CART_SOURCES: ["product-form", "cart-items"],
    SELECTORS: {
      SLIDER_CONTAINER: ".add-on-mobile--swiper .add-on--card-list",
      MOBILE_WRAPPER: ".add-on-mobile--swiper",
      PROGRESS_CONTAINER: ".scroll-progress-container",
      PROGRESS_BAR: "#CartDrawer .add-on-mobile--swiper .scroll-progress",
      SINGLE_CARD: ".add-on-mobile--swiper .add-on--card",
      CART_DRAWER: "#CartDrawer",
    },
  }

  constructor() {
    // State management
    this.initialized = false
    this.swiperInstance = null
    this.currentSlidesCount = 0
    this.isInitializing = false

    // DOM cache (invalidated on cart updates)
    this.domCache = {
      container: null,
      progressBar: null,
      progressContainer: null,
      mobileWrapper: null,
    }

    // Event listener cleanup references
    this.eventCleanup = []
    this.scrollProgressHandler = null

    // Media query for better performance than resize events
    this.desktopMediaQuery = window.matchMedia(
      `(min-width: ${CartAddOnSlider.CONFIG.DESKTOP_BREAKPOINT}px)`,
    )

    // Bound methods for proper cleanup
    this.boundHandleResize = debounce(
      this.handleResize.bind(this),
      CartAddOnSlider.CONFIG.RESIZE_DEBOUNCE,
    )
    this.boundHandleCartUpdate = this.handleCartUpdate.bind(this)
    this.boundHandleMediaChange = this.handleMediaChange.bind(this)

    // Initialize
    this.init()
  }

  init() {
    if (this.initialized) return

    // Setup event listeners first (these are always needed)
    this.setupEventListeners()

    // Try to initialize slider (may not exist yet on page load)
    this.initAddOnScrollProgress()
    this.initializeAddOnSlider()

    this.initialized = true
  }

  /**
   * Cache DOM elements to reduce querySelector calls
   */
  cacheDOMElements() {
    const config = CartAddOnSlider.CONFIG.SELECTORS
    this.domCache.container = document.querySelector(config.SLIDER_CONTAINER)
    this.domCache.progressBar = document.querySelector(config.PROGRESS_BAR)
    this.domCache.progressContainer = document.querySelector(
      config.PROGRESS_CONTAINER,
    )
    this.domCache.mobileWrapper = document.querySelector(config.MOBILE_WRAPPER)
  }

  /**
   * Clear DOM cache (call after DOM updates)
   */
  clearDOMCache() {
    this.domCache = {
      container: null,
      progressBar: null,
      progressContainer: null,
      mobileWrapper: null,
    }
  }

  /**
   * Check if running on mobile/tablet
   */
  isMobile() {
    return !this.desktopMediaQuery.matches
  }

  /**
   * Wait for Swiper library to be available
   */
  waitForSwiper(callback, retryCount = 0) {
    const config = CartAddOnSlider.CONFIG

    if (typeof window.Swiper !== "undefined") {
      callback()
    } else if (retryCount < config.SWIPER_MAX_RETRIES) {
      setTimeout(
        () => this.waitForSwiper(callback, retryCount + 1),
        config.SWIPER_RETRY_DELAY,
      )
    } else {
      console.warn(
        "[CartAddOnSlider] Swiper library not available after maximum retries",
        {
          retries: config.SWIPER_MAX_RETRIES,
          swiperDefined: typeof window.Swiper !== "undefined",
        },
      )
    }
  }

  /**
   * Get Swiper configuration
   */
  getSwiperConfig(paginationEl) {
    return {
      slidesPerView: 1.2,
      spaceBetween: 0,
      grabCursor: true,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
    }
  }

  /**
   * Prepare DOM structure for Swiper
   */
  prepareSwiperStructure(container) {
    // Wrap children in swiper-wrapper if not already wrapped
    if (!container.querySelector(".swiper-wrapper")) {
      const wrapper = document.createElement("div")
      wrapper.className = "swiper-wrapper"

      // Use Array.from to convert children HTMLCollection to array
      // This prevents issues with live collections while moving elements
      const childElements = Array.from(container.children)

      // Use document fragment for better performance
      childElements.forEach((child) => {
        child.classList.add("swiper-slide")
        wrapper.appendChild(child)
      })

      container.appendChild(wrapper)
    } else {
      // Ensure all children have swiper-slide class
      const slides = container.querySelectorAll(".swiper-wrapper > *")
      slides.forEach((slide) => slide.classList.add("swiper-slide"))
    }
  }

  /**
   * Create or get pagination element
   */
  getPaginationElement(container) {
    let paginationEl =
      container.parentElement?.querySelector(".swiper-pagination")

    if (!paginationEl && container.parentElement) {
      paginationEl = document.createElement("div")
      paginationEl.className = "swiper-pagination"
      container.parentElement.appendChild(paginationEl)
    }

    return paginationEl
  }

  /**
   * Create Swiper instance
   */
  createSwiperInstance(container) {
    try {
      // Add necessary Swiper classes
      container.classList.add("swiper")
      this.domCache.mobileWrapper?.classList.add("swiper-initialized")

      // Prepare structure
      this.prepareSwiperStructure(container)

      // Create pagination
      const paginationEl = this.getPaginationElement(container)

      // Initialize Swiper
      this.swiperInstance = new Swiper(
        container,
        this.getSwiperConfig(paginationEl),
      )

      // Hide fallback progress container
      if (this.domCache.progressContainer) {
        this.domCache.progressContainer.style.display = "none"
      }

      return true
    } catch (error) {
      console.error("[CartAddOnSlider] Error creating Swiper instance:", error)
      return false
    }
  }

  /**
   * Handle single card display
   */
  handleSingleCard(container) {
    const config = CartAddOnSlider.CONFIG

    const singleCard = document.querySelector(config.SELECTORS.SINGLE_CARD)
    if (!singleCard) return

    // Hide progress container
    if (this.domCache.progressContainer) {
      this.domCache.progressContainer.style.display = "none"
    }

    // Batch DOM writes
    requestAnimationFrame(() => {
      container.style.display = "flex"

      const parentContainer = container.closest(config.SELECTORS.MOBILE_WRAPPER)
      if (parentContainer) {
        const isTablet = window.innerWidth > config.TABLET_BREAKPOINT
        parentContainer.style.paddingRight = isTablet ? "4rem" : "1.6rem"
      }
    })
  }

  /**
   * Clean up existing Swiper instance
   */
  cleanupSwiper() {
    if (
      this.swiperInstance &&
      typeof this.swiperInstance.destroy === "function"
    ) {
      try {
        this.swiperInstance.destroy(true, true)
      } catch (error) {
        console.warn("[CartAddOnSlider] Error destroying Swiper:", error)
      } finally {
        this.swiperInstance = null
      }
    }
  }

  /**
   * Main initialization method for add-on slider
   */
  initializeAddOnSlider() {
    // Prevent concurrent initialization
    if (this.isInitializing) return
    this.isInitializing = true

    // Wait for Swiper to be available before initializing
    this.waitForSwiper(() => {
      try {
        // Clear cache and re-query elements
        this.clearDOMCache()
        this.cacheDOMElements()

        const container = this.domCache.container

        // Check if element exists
        if (!container) {
          this.isInitializing = false
          return
        }

        const slidesCount = container.children.length

        // Check if existing Swiper instance is still valid (attached to DOM)
        const isSwiperStillValid =
          this.swiperInstance &&
          this.swiperInstance.el &&
          document.contains(this.swiperInstance.el)

        // Skip re-initialization if nothing changed AND Swiper is still valid
        if (
          slidesCount === this.currentSlidesCount &&
          isSwiperStillValid &&
          slidesCount > 1
        ) {
          this.isInitializing = false
          return
        }

        // Update state
        this.currentSlidesCount = slidesCount

        // Destroy existing instance
        this.cleanupSwiper()

        // Re-init Swiper if more than one item
        if (slidesCount > 1) {
          this.createSwiperInstance(container)
        } else if (slidesCount === 1) {
          this.handleSingleCard(container)
        }
      } catch (error) {
        console.error("[CartAddOnSlider] Error initializing slider:", error)
      } finally {
        this.isInitializing = false
      }
    })
  }

  /**
   * Handle window resize
   */
  handleResize() {
    if (this.isMobile()) {
      this.initializeAddOnSlider()
    }
  }

  /**
   * Handle media query change
   */
  handleMediaChange(e) {
    if (!e.matches) {
      // Switched to mobile
      this.initializeAddOnSlider()
    }
  }

  /**
   * Handle cart update events
   */
  handleCartUpdate(event) {
    if (!this.isMobile()) return

    const config = CartAddOnSlider.CONFIG

    // Skip if source should be ignored
    if (config.IGNORED_CART_SOURCES.includes(event?.source)) {
      return
    }

    // Clear cache since DOM was updated
    this.clearDOMCache()

    const addOnSlider = document.querySelector(
      config.SELECTORS.SLIDER_CONTAINER,
    )

    if (!addOnSlider) return

    // Add a small delay to let the DOM settle after refresh
    setTimeout(() => {
      this.initAddOnScrollProgress()
      this.initializeAddOnSlider()
    }, config.CART_UPDATE_DELAY)
  }

  /**
   * Setup all event listeners with proper cleanup tracking
   */
  setupEventListeners() {
    // Window resize listener (with debounce)
    window.addEventListener("resize", this.boundHandleResize)
    this.eventCleanup.push(() => {
      window.removeEventListener("resize", this.boundHandleResize)
    })

    // Media query listener (more efficient than resize for breakpoint changes)
    if (this.desktopMediaQuery.addEventListener) {
      this.desktopMediaQuery.addEventListener(
        "change",
        this.boundHandleMediaChange,
      )
      this.eventCleanup.push(() => {
        this.desktopMediaQuery.removeEventListener(
          "change",
          this.boundHandleMediaChange,
        )
      })
    }

    // Cart update pub-sub listener
    if (typeof subscribe === "function") {
      const unsubscribe = subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        this.boundHandleCartUpdate,
      )

      // Store unsubscribe function if available
      if (typeof unsubscribe === "function") {
        this.eventCleanup.push(unsubscribe)
      }
    }
  }

  /**
   * Initialize scroll progress (fallback for non-swiper view)
   */
  initAddOnScrollProgress() {
    const config = CartAddOnSlider.CONFIG.SELECTORS
    const container = document.querySelector(
      `${config.CART_DRAWER} ${config.SLIDER_CONTAINER}:not(.swiper-initialized)`,
    )
    const progressBar = document.querySelector(config.PROGRESS_BAR)

    if (!container || !progressBar) {
      return
    }

    // Remove previous listener if exists
    if (this.scrollProgressHandler) {
      container.removeEventListener("scroll", this.scrollProgressHandler)
    }

    // Create new handler
    this.scrollProgressHandler = () => {
      requestAnimationFrame(() => {
        const scrollLeft = container.scrollLeft
        const scrollWidth = container.scrollWidth
        const clientWidth = container.clientWidth
        const maxScroll = scrollWidth - clientWidth
        const totalGrids = container.querySelectorAll(".add-on--card").length

        let percent = 0
        if (maxScroll > 0) {
          const rawPercent = scrollLeft / maxScroll
          const scrollWidthPercent = 100 / totalGrids
          percent = Math.min(scrollWidthPercent + rawPercent * 75, 100)
        }

        progressBar.style.width = `${percent}%`
      })
    }

    // Add listener
    container.addEventListener("scroll", this.scrollProgressHandler, {
      passive: true,
    })

    // Initial update
    this.scrollProgressHandler()
  }

  /**
   * Cleanup method for proper resource disposal
   */
  destroy() {
    // Cleanup Swiper
    this.cleanupSwiper()

    // Remove all event listeners
    this.eventCleanup.forEach((cleanup) => {
      try {
        cleanup()
      } catch (error) {
        console.warn("[CartAddOnSlider] Error during cleanup:", error)
      }
    })
    this.eventCleanup = []

    // Clear DOM cache
    this.clearDOMCache()

    // Reset state
    this.initialized = false
    this.currentSlidesCount = 0
    this.scrollProgressHandler = null
  }
}

// Initialize Cart Add-On Slider
document.addEventListener("DOMContentLoaded", () => {
  new CartAddOnSlider()
})

window.addOnrefreshCartDrawer = function () {
  // The section ID may vary based on your theme setup
  fetch(window.location.pathname + "?sections=cart-drawer")
    .then((response) => response.json())
    .then((data) => {
      // Update the cart drawer HTML
      if (data["cart-drawer"]) {
        const cartDrawer = document.querySelector("#CartDrawer")
        if (cartDrawer) {
          cartDrawer.innerHTML = new DOMParser()
            .parseFromString(data["cart-drawer"], "text/html")
            .querySelector("#CartDrawer").innerHTML

          const overlay =
            cartDrawer.querySelector("#CartDrawer-Overlay") ||
            cartDrawer.querySelector(".cart-drawer__overlay")
          if (overlay) {
            overlay.addEventListener("click", function () {
              document.querySelector(".drawer__close").click()
            })
          }
        }
      }
    })
    .catch((error) => {})
    .finally(() => {
      // Publish the event to signal the cart needs to be refreshed
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "addOnrefreshCartDrawer",
        cartData: null,
      })
    })
}

window.addEventListener("pageshow", async () => {
  const addOnWrapper = document.querySelector(
    ".cart-drawer-add-ons--drawer .add-on--card-list",
  )
  if (addOnWrapper && addOnWrapper.children.length < 1) {
    addOnWrapper.remove()
    document.querySelector(".cart-drawer-add-ons--drawer").remove()
  }
})

document.addEventListener("click", function (e) {
  const button = e.target.closest(".add-on__new_submit")
  if (!button) return

  e.preventDefault()

  const variantId = button.getAttribute("data-variant-id")
  if (!variantId) {
    return
  }

  button.disabled = true
  const originalText = button.textContent
  button.textContent = "Adding..."

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
    .then((res) => {
      if (!res.ok) throw new Error("Failed to add item")
      return fetch("/cart.js")
    })
    .then((res) => res.json())
    .then((cart) => {
      document.querySelector(".cart-count-bubble").innerHTML =
        `<span data-cart-count="" aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} items</span>`
      const cartDrawer =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer")

      if (cartDrawer) {
        cartDrawer.refreshFromServer()
      }
    })
    .catch((err) => {})
    .finally(() => {
      button.disabled = false
      button.textContent = originalText
    })
})

// Discount Counter Timer Script for Shopify server time sync
const countdownTimers = new WeakMap()

function getLocalTimestampFromOffset(offsetMinutes) {
  const nowUTC = new Date().getTimezoneOffset()
  return nowUTC + offsetMinutes * 60 * 1000
}

function startDiscountCountdowns() {
  const countdownEls = document.querySelectorAll(".discount-count-down")
  if (!countdownEls.length) return

  countdownEls.forEach((el) => {
    const collapseTimeStr = el.getAttribute("data-timer-collapse")
    if (!collapseTimeStr) return

    // Convert collapse time to UTC timestamp (no extra offset added here!)
    const collapseTime = new Date(collapseTimeStr.replace(" ", "T")).getTime()
    // Labels
    let dayLabel = el.getAttribute("data-days-label") || "d"
    let hrsLabel = el.getAttribute("data-hrs-label") || "h"
    const minLabel = el.getAttribute("data-min-label") || "m"
    const secLabel = el.getAttribute("data-sec-label") || "s"
    const colons = el.getAttribute("data-lang") === "en" ? ":" : ""

    const parent = el.closest(".page-discount-timer.show-timer")
    if (parent) parent.style.display = "flex"

    const pdpTimers = document.querySelectorAll(
      ".upsell_produt #discount-timer",
    )

    pdpTimers.forEach((timer, index) => {
      if (index > 0) {
        // Skip the first timer
        timer.style.display = "none"
      }
    })

    function updateCountdown() {
      const now = new Date()

      // Get UTC timestamp in milliseconds
      const utcTimestamp = now.getTime() + now.getTimezoneOffset() * 60 * 1000

      // Convert UTC time to store local time
      const storeNow = utcTimestamp + storeOffsetMinutes * 60 * 1000

      // Calculate difference between collapse time and store time
      const diffMs = collapseTime - storeNow

      if (diffMs <= 0) {
        el.textContent = `Expired`
        el.closest(".page-discount-timer").remove()
        clearInterval(timer)
        location.reload()

        return
      }

      const totalSeconds = Math.floor(diffMs / 1000)
      const totalMinutes = Math.floor(totalSeconds / 60)
      const totalHours = Math.floor(totalMinutes / 60)
      const totalDays = Math.floor(totalHours / 24)

      const hours = totalHours % 24
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60

      if (totalHours >= 24) {
        if (totalDays === 1 && dayLabel === "days") dayLabel = "day"
        el.textContent = `${totalDays} ${dayLabel}`
      } else if (totalHours >= 1) {
        if (totalHours === 1 && hrsLabel === "hrs") hrsLabel = "hr"
        el.textContent = `${hours} ${hrsLabel} ${colons} ${minutes} ${minLabel}`
      } else if (totalMinutes >= 1) {
        el.textContent = `${minutes} ${minLabel} ${colons} ${seconds} ${secLabel}`
      } else {
        el.textContent = `${seconds} ${secLabel}`
      }
    }

    updateCountdown()
    const timer = setInterval(updateCountdown, 1000)
  })
}

document.addEventListener("DOMContentLoaded", startDiscountCountdowns)
document.addEventListener("pageshow", startDiscountCountdowns)

function checkProductCardsPromoTextHeight() {
  setTimeout(function () {
    const promoTexts = document.querySelectorAll(
      ".promotional-messaging-bottom-text",
    )

    if (promoTexts.length === 0) {
    } else {
      let maxHeight = 0

      promoTexts.forEach((el) => {
        const height = el.offsetHeight
        if (height > maxHeight) {
          maxHeight = height
        }
      })

      promoTexts.forEach((el) => {
        el.style.height = maxHeight + "px"
      })
    }
  }, 700)
}

document.addEventListener("click", function (e) {
  if (e.target.closest(".custom-product-swatches")) {
    checkProductCardsPromoTextHeight()
  }
})

document.addEventListener("DOMContentLoaded", checkProductCardsPromoTextHeight)
window.addEventListener("resize", checkProductCardsPromoTextHeight)
